import * as yup from "yup";
const phoneRegExp = /^(010|011|012|015)\d{8}$/;
const emailRegExp = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
const phoneRegExp2 = /^(10|11|12|15)\d{8}$/;
const anotherCountryPhoneRegExp = /^(?:50|51|52|54|55|56|58|2|3|4|6|7|9)\d{7}$/;
const amountRegExp = /^\d+$/;
const nationalIdRegex =
  /^[23]\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{5}\d{2}$/;

const fileSchema = yup
  .mixed()
  .test(
    "fileSize",
    "يجب أن يكون أقل من 5 ميغابايت",
    (value) => !value || (value && value.size <= 5 * 1024 * 1024),
  )
  .test(
    "fileType",
    "نوع الملف غير صحيح. يرجى تحميل نوع الملف الصحيح",
    (value) =>
      !value ||
      (value && value.type === "application/pdf") ||
      value?.type.startsWith("image/"),
  );

const baseSchema = (flag, country) => {
  let schema = yup.object().shape({
    name: yup
      .string()
      .trim()
      .min(3, "الإسم يجب ان يكون على الأقل 3 حروف")
      .matches(/^[\u0600-\u06FF\s]+$/, "يسمح فقط بالحروف العربية والمسافات")
      .required("اجباري"),

    email: yup
      .string()
      .matches(emailRegExp, "برجاء ادخال ايميل صحيح")
      .required("اجباري"),
    nationalId: yup
      .string()
      .matches(nationalIdRegex, "برجاء ادخال الرقم القومي الصحيح")
      .min(14, "يجب أن يكون 14 رقم")
      .max(14, "يجب أن يكون 14 رقم")
      .trim(),
    governance: yup.string().nullable().notRequired(),
    preferredCallingTime: yup.string().required("اجباري"),
  });
  if (flag === "product") {
    if (country === "مصر") {
      schema = schema.shape({
        mobilePhone: yup
          .string()
          .matches(
            phoneRegExp2,
            "رقم الهاتف يجب أن يبدأ بـ (10/11/12/15) وعلى الاقل 10 ارقام",
          )
          .min(10, "يجب أن يكون 10 رقم")
          .max(10, "يجب أن يكون 10 رقم")
          .required("اجباري"),
      });
    } else if (country === "الامارات") {
      schema = schema.shape({
        mobilePhone: yup
          .string()
          .min(9, "يجب أن يكون 9 رقم")
          .max(9, "يجب أن يكون 9 رقم")
          .matches(
            anotherCountryPhoneRegExp,
            "يجب أن يبدأ رقم الهاتف بـ (50/51/52/54/55/56/58) مباشرة",
          )
          .required("اجباري"),
        passportUrl: fileSchema.required("اجباري"),
        workPermitUrl: fileSchema.notRequired(),
        hrLetter: fileSchema.notRequired(),
        bankStatementUrl: fileSchema.notRequired(),
        EgyptAddress: yup.string().trim().required("اجباري"),
      });
    } else {
      schema = schema.shape({
        mobilePhone: yup
          .string()
          .matches(
            phoneRegExp,
            "رقم الهاتف يجب أن يبدأ بـ (010/011/012/015) وعلى الاقل 11 رقم",
          )
          .min(11, "يجب أن يكون 11 رقم")
          .max(11, "يجب أن يكون 11 رقم")
          .required("اجباري"),
      });
    }
  } else {
    schema = schema.shape({
      mobilePhone: yup
        .string()
        .matches(
          phoneRegExp,
          "رقم الهاتف يجب أن يبدأ بـ (010/011/012/015) وعلى الاقل 11 رقم",
        )
        .min(11, "يجب أن يكون 11 رقم")
        .max(11, "يجب أن يكون 11 رقم")
        .required("اجباري"),
    });
  }
  return schema;
};
export const ArSchema = (flag, country) => {
  const schema = baseSchema(flag, country);
  return schema;
};
export const ArCampaignSchema = (type) =>
  yup.object().shape({
    name: yup.string().min(3, "الإسم يجب ان يكون على الأقل 3 حروف").required("اجباري"),

    email: yup
      .string()
      .matches(emailRegExp, "برجاء ادخال ايميل صحيح")
      .required("اجباري"),

    mobilePhone: yup
      .string()
      .matches(
        phoneRegExp,
        "رقم الهاتف يجب أن يبدا بـ (010/011/012/015) وعلى الاقل 11 رقم"
      )
      .min(11, "يجب أن يكون 11 رقم")
      .max(11, "يجب أن يكون 11 رقم")
      .required("اجباري"),

    products:  type === "exclusive-offers" ?  yup.string().notRequired(): yup.string().required("اجباري"),

    preferredCallingTime:
      type === "catalogue"
        ? yup
            .string()
            .required("اجباري")
            .test("not-default", "اجباري", (v) => !!v && v !== "default")
        : yup.string().notRequired(),
  });

export const ArSchemaA = (flag, country) => {
  const schema = baseSchema(flag, country);
  return schema;
};
export const ArSchemaB = (flag, country) => {
  const schema = baseSchema(flag, country).concat(
    yup.object().shape({
      products: yup.string().required("اجباري"),
    }),
  );
  return schema;
};
export const ArMortgageSchema = (flag, country) => {
  const schema = baseSchema(flag, country).concat(
    yup.object().shape({
      mortgageType: yup.string().required("اجباري"),
    }),
  );
  return schema;
};
export const ArSchema_Application = (flag, country) => {
  const schema = baseSchema(flag, country).concat(
    yup.object().shape({
      job: yup.string().required("اجباري"),
      resumeUrl: yup.string().required("اجباري"),
      resumeUrl: yup
        .string()
        .url("يجب أن يكون رابطًا صالحًا")
        .required("اجباري"),
      governance: yup.string().nullable().notRequired(),
      governorate: yup.string().required("اجباري"),
      preferredCallingTime: yup.string().notRequired(""),
    }),
  );
  return schema;
};
export const ArOffersSchema = yup.object().shape({
  name: yup
    .string()
    .trim()
    .min(3, "الإسم يجب ان يكون على الأقل 3 حروف")
    .matches(/^[\u0600-\u06FF\s]+$/, "يسمح فقط بالحروف العربية والمسافات")
    .required("اجباري"),

  email: yup
    .string()
    .matches(emailRegExp, "برجاء ادخال ايميل صحيح")
    .required("اجباري"),

  mobilePhone: yup
    .string()
    .matches(
      phoneRegExp,
      "رقم الهاتف يجب أن يبدأ بـ (010/011/012/015) وعلى الاقل 11 رقم",
    )
    .min(11, "يجب أن يكون 11 رقم")
    .max(11, "يجب أن يكون 11 رقم")
    .required("اجباري"),
});
